export default __webpack_public_path__ + "static/media/KylaNorris.9cae5e90.jpg";